import { getUrl } from 'aws-amplify/storage'
import React, { useState } from 'react'

import { useAxios } from '../../utilities/Requests/useAxios'

export type MUMRecordObj = {
  id: number
  videoStorageKey: string
  recordDate: string
  reviewed: boolean
  reviewedBy: string
  reviewedAt: string
  flaggedForIncident: boolean
  flaggedBy: string
  flaggedAt: string
  videoURL: string
}

export interface MUMContextInterface {
  MUMRecords: MUMRecordObj[]
  getPatientMUMRecords: (patientId: number) => Promise<any>
  reviewMumRecord: (mumRecordId: number) => Promise<any>
  flagMumRecordForIncident: (mumRecordId: number) => Promise<any>
}

export const MUMContext = React.createContext<MUMContextInterface | null>(null)

export const MUMProvider = ({ children }: any) => {
  const { fetch } = useAxios()

  const [MUMRecords, setMUMRecords] = useState<MUMRecordObj[]>([])

  const getPatientMUMRecords = async (patientId: number) => {
    const { data, error } = await fetch({
      path: `Mum/GetPatientMumRecords?patientId=${patientId}`,
    })
    if (data) {
      const dataWithVideoPromises = data.map(async (r: MUMRecordObj) => {
        if (r.videoStorageKey) {
          const path = r.videoStorageKey.startsWith('public/')
            ? r.videoStorageKey
            : `public/${r.videoStorageKey}`
          const { url } = await getUrl({ path })
          r.videoURL = url.toString()
        }
        return r
      })
      const dataWithVideo = await Promise.all(dataWithVideoPromises)
      const sortedData = dataWithVideo.sort(
        (v1: MUMRecordObj, v2: MUMRecordObj) =>
          new Date(v2.recordDate).getTime() - new Date(v1.recordDate).getTime()
      )
      setMUMRecords(sortedData)
      return sortedData
    } else {
      console.warn(`getPatientMUMRecords-error: ${error}`)
    }
  }

  const reviewMumRecord = async (mumRecordId: number) => {
    const { error } = await fetch({
      path: `Mum/ReviewMumRecord?mumRecordId=${mumRecordId}`,
      methodType: 'PUT',
    })
    if (error) {
      console.warn(`reviewMumRecord-error: ${error}`)
    }
  }

  const flagMumRecordForIncident = async (mumRecordId: number) => {
    const { error } = await fetch({
      path: `Mum/FlagForIncident?mumRecordId=${mumRecordId}`,
      methodType: 'PUT',
    })
    if (error) {
      console.warn(`error in flagMumRecordForIncident: ${error}`)
    }
  }

  return (
    <MUMContext.Provider
      value={{
        MUMRecords,
        getPatientMUMRecords,
        reviewMumRecord,
        flagMumRecordForIncident,
      }}
    >
      {children}
    </MUMContext.Provider>
  )
}
